module.exports = __webpack_public_path__ + "img/placeholder_header_3.606b3fd9.jpg";